import { Features } from '@tock/coretypes';
import { createFeaturesObject } from '@tock/shared/state/featureUtils';
import AppConstants from 'constants/AppConstants';
import _ from 'lodash';

interface State {
  features: Features;
  globalFeatures?: Features;
}

export const initialState: State = {
  features: {},
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.CONFIG_FETCH_DONE: {
      const features = createFeaturesObject(payload);

      return {
        features: !_.isEmpty(features) ? features : {},
      };
    }
    default:
      return state;
  }
}
